const FALLBACK_TARGET = '/'

export default defineNuxtRouteMiddleware((to, from) => {
  const { navigateToLocalized } = useRouterUtils()
  if (to.fullPath === from.fullPath) {
    const { redirect, ...rest } = to.query
    return navigateToLocalized({ path: FALLBACK_TARGET, query: rest })
  }
})
